import React from 'react';
import { IModel } from '@api/models/user/interface';
import cn from 'classnames';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import starLottie from 'src/assets/profile/star-lottie.json';
import starShieldLottie from 'src/assets/profile/star-shield-lottie.json';
import torchLottie from 'src/assets/profile/torch-lottie.json';
import trophyLottie from 'src/assets/profile/trophy-lottie.json';
import LiquidGlassEffect from 'src/components/common/LiquidGlassEffect';

import css from './RankProgress.module.scss';
import { StarIcon } from './StarIcon';
import { TorchIcon } from './TorchIcon';
import { TrophyIcon } from './TrophyIcon';

const RANKS_LOTTIE_MAP = {
  spark: starLottie,
  torch: torchLottie,
  lighthouse: starShieldLottie,
  ['shield-wall']: trophyLottie,
};

interface Props {
  className?: string;
  rank: IModel['rank'];
}
export const RankProgress: React.FC<Props> = ({ className = '', rank }) => {
  const lottieRef = React.useRef<LottieRefCurrentProps>(null);

  return (
    <div className={cn(css.rankProgress, className, css.bubbleShadow)}>
      <div className={cn(css.activeRank, css[rank], css.bubbleShadow)}>
        <Lottie lottieRef={lottieRef} animationData={RANKS_LOTTIE_MAP[rank]} loop autoplay />
      </div>
      <div className={cn(css.rankProgressBar, css[rank])} />
      <div className={cn(css.ranksList, css[rank])}>
        <div className={cn(css.rank, css.spark)}>
          <StarIcon />
        </div>
        <div className={cn(css.rank, css.torch)}>
          <TorchIcon />
        </div>
        <div className={cn(css.rank, css.lighthouse)}>
          <StarIcon />
        </div>
        <div className={cn(css.rank, css.shieldWall)}>
          <TrophyIcon />
        </div>
      </div>
    </div>
  );
};
